import theme from '../../../theme.js';
import { BiPyramid } from 'react-icons/bi';
import { FaDiceD6 } from 'react-icons/fa';
import { GiDiceEightFacesEight, GiD10, GiD12 } from 'react-icons/gi';

export const minVal = 2;
export const maxVal = 9;
export const leftStart = 5;
export const rightStart = 6;

export const healthName = 'Health';
export const resilienceName = 'Resilience';

export const TraitsDictionary = {
  charm: {
    name: 'Charm',
    abbr: 'CHRM',
    summary: 'This is a summary for charm',
    link: '',
    leftSide: {
      name: 'Introvert',
      abbr: 'INTRO',
      summary: 'This is a summary for introvert',
      link: '',
    },
    rightSide: {
      name: 'Extrovert',
      abbr: 'EXTRO',
      summary: 'This is a summary for extrovert',
      link: '',
    },
  },
  athletics: {
    name: 'Athletics',
    abbr: 'ATHL',
    summary: 'This is a summary for athletics',
    link: '',
    leftSide: {
      name: 'Feather Weight',
      abbr: 'FTHR WGHT',
      summary: 'This is a summary for feather weight',
      link: '',
    },
    rightSide: {
      name: 'Heavy Weight',
      abbr: 'HVY WGHT',
      summary: 'This is a summary for heavy weight',
      link: '',
    },
  },
  tough: {
    name: 'Tough',
    abbr: 'TGH',
    summary: 'This is a summary for tough',
    link: '',
    leftSide: {
      name: 'Defense',
      abbr: 'DEF',
      summary: 'This is a summary for defense',
      link: '',
    },
    rightSide: {
      name: 'Offense',
      abbr: 'OFF',
      summary: 'This is a summary for offense',
      link: '',
    },
  },
  sharp: {
    name: 'Sharp',
    abbr: 'SHRP',
    summary: 'This is a summary for sharp',
    link: '',
    leftSide: {
      name: 'Hindsight',
      abbr: 'HNDSGHT',
      summary: 'This is a summary for hindsight',
      link: '',
    },
    rightSide: {
      name: 'Foresight',
      abbr: 'FRSGHT',
      summary: 'This is a summary for foresight',
      link: '',
    },
  },
  belief: {
    name: 'Belief',
    abbr: 'BLF',
    summary: 'This is a summary for belief',
    link: '',
    leftSide: {
      name: 'Logical',
      abbr: 'LOGIC',
      summary: 'This is a summary for logical',
      link: '',
    },
    rightSide: {
      name: 'Fantastical',
      abbr: 'FNTSY',
      summary: 'This is a summary for fantastical',
      link: '',
    },
  },
};

export const HealthAttributes = {
  health: {
    name: healthName,
    action: 'Heal',
    baseColor: theme.colors.rightSideLight,
    highlightColor: theme.colors.rightSideMedium,
    selectColor: theme.colors.rightSideMain,
  },
  resilience: {
    name: resilienceName,
    action: 'Repair',
    baseColor: theme.colors.leftSideLight,
    highlightColor: theme.colors.leftSideMedium,
    selectColor: theme.colors.leftSideMain,
  },
};

export const DiceDictionary = {
  0: [4, BiPyramid],
  1: [6, FaDiceD6],
  2: [8, GiDiceEightFacesEight],
  3: [10, GiD10],
  4: [12, GiD12],
};

export const TraitSide = Object.freeze({
  Left: 'left',
  Center: 'center',
  Right: 'right',
});
